import Icon from './Icon'
import type { IconProps } from './Icon'

export type { IconProps }
export default Icon
